import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { CallRecordingService } from '../services/CallRecordingService';
import { toast } from "react-toastify";
import useWebSocket, { ReadyState } from 'react-use-websocket';
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './callRecording.css'
import { useCountdown } from './callProgressTimer';
import { configuration } from '../configs';

type CallRecordingData = {
  firstCall: CallRecordingFirstFormData,
  caller2?: CallRecordingParticipantFormData,
  sessionId: string,
  callback?: callBackMessage,
  caller3?: CallRecordingParticipantFormData,
  caller4?: CallRecordingParticipantFormData,
  caller5?: CallRecordingParticipantFormData
}

type callBackMessage = {
  CallState: number,
  Message: string
}

type CallRecordingFirstFormData = {
  recordingName: string,
  firstNumber: string,
  studyName: string
};

type CallRecordingParticipantFormData = {
  participantNumber: string,
  callerIndex: number
};

const CallRecording = () => {
  const [isFirstCallStarted, setIsFirstCallStarted] = useState(false);
  const [isSecondCallStarted, setIsSecondCallStarted] = useState(false);
  const [isThirdCallStarted, setIsThirdCallStarted] = useState(false);
  const [isForthCallStarted, setIsForthCallStarted] = useState(false);
  const [isFifthCallStarted, setIsFifthCallStarted] = useState(false);
  const [callRecordingData, setCallRecordingData] = useState<CallRecordingData | any>(null);
  const [isRecordingStopped, setIsRecordingStopped] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [loginNumber, SetLoginNumber] = useState('');
  const [loggedInUserInfo, setLoggedInUserInfo] = useState<any>(null);
  const [isFirstPlaceCallButtonDisable, setIsFirstPlaceCallButtonDisable] = useState(false);
  const [isSecondPlaceCallButtonDisable, setIsSecondPlaceCallButtonDisable] = useState(false);
  const [isThirdPlaceCallButtonDisable, setIsThirdPlaceCallButtonDisable] = useState(false);
  const [isForthPlaceCallButtonDisable, setIsForthPlaceCallButtonDisable] = useState(false);
  const [isFifithPlaceCallButtonDisable, setIsFifthPlaceCallButtonDisable] = useState(false);
  const [isRecordingButtonDisable, setIsRecordingButtonDisable] = useState(false);
  const [isCallTerminatedManually, setIsCallTerminatedManually] = useState(false);
  const [clockTime, timerOutput, isTimerRunning, setIsTimerRunning, setResetTimer] = useCountdown(0);
  const [isAddThirdCaller, setIsAddThirdCaller] = useState(false);
  const [isAddForthCaller, setIsAddForthCaller] = useState(false);
  const [isAddFifthCaller, setIsAddFifthCaller] = useState(false);


  const callRecordingSessionKey = "callRecordingSessionKey";
  const WS_URL = configuration.WS_BASE_URL; //process.env.REACT_APP_WS_BASE_URL;
  const { sendJsonMessage, readyState } = useWebSocket(WS_URL, {
    onOpen: (event) => {
    },
    onMessage(event) {
      if (isJson(event.data)) {
        const message = JSON.parse(event.data);
        if (!isCallTerminatedManually) {
          setCallRecordingData((call: CallRecordingData) => ({ ...call, callback: message }));
        }
        handleReceivedMessage(message);
      }
    },
    reconnectAttempts: 100,
    onReconnectStop(numAttempts) {
    },
    onClose(event) {
    },
    shouldReconnect: (closeEvent) => true
  });

  useEffect(() => {
    if (callRecordingData?.sessionId && readyState === ReadyState.OPEN) {
      notifyServer(callRecordingData?.sessionId);
    }
  }, [readyState]);

  const handleReceivedMessage = (message: any) => {
    switch (message.CallState) {
      case "1": //Caller1Established
        setIsRecordingStopped(true);
        toast.info(message.Message);
        break;
      case "2"://Caller1Failed 
        resetCaller(1);
        toast.info(message.Message);
        break;
      case "3"://Caller2Established
        setIsInProgress(true);
        setIsTimerRunning(true);
        setIsRecordingStopped(false);
        toast.info(message.Message);
        break;
      case "4"://Caller2Failed
        resetCaller(2)
        toast.info(message.Message);
        break;
      case "5"://CallTerminated
        if (callRecordingData?.firstCall && !isCallTerminatedManually && !isFirstCallStarted && !isSecondCallStarted) {
          toast.info("First participant is not answering the call");
        }
        else {
          toast.info(message.Message);
        }
        
        setIsInProgress(false);
        resetCallRecording();
        break;
      case "6"://CallerDisconnected
        console.log(`Message: ${message.Message}`)
        if (callRecordingData?.firstCall) {
          if (isFirstCallStarted && message.Message.includes(callRecordingData.firstCall.firstNumber)) {
            resetCaller(1);
            toast.warn(`First participant ${message.Message}`);
            onTerminateCall();
          }
          else if (message.Message.includes(callRecordingData.caller2?.participantNumber)) {
            resetCaller(2);
            toast.warn(`Second participant ${message.Message}, retry!`);
          }
          else if (message.Message.includes(callRecordingData.caller3?.participantNumber)) {
            resetCaller(3);
            toast.warn(`Third participant ${message.Message}, retry!`);
          }
          else if (message.Message.includes(callRecordingData.caller4?.participantNumber)) {
            resetCaller(4);
            toast.warn(`Forth participant ${message.Message}, retry!`);
          }
          else if (message.Message.includes(callRecordingData.caller5?.participantNumber)) {
            resetCaller(5);
            toast.warn(`Fifth participant ${message.Message}, retry!`);
          }
        }
        break;
      case "8": //Caller3Established
      case "11": //Caller4Established
      case "14": //Caller5Established
        toast.info(message.Message);
        break;
      default:
        break;
    }
  }

  const resetCaller = (caller: number) => {
    if (caller === 1) {
      setCallRecordingData(null);
    }
    else if (caller === 2) {
      setCallRecordingData((call: CallRecordingData) => ({ ...call, caller2: null }));
    }
  }

  useEffect(() => {
    const callRecordingSessionValue = sessionStorage.getItem(callRecordingSessionKey);
    if (callRecordingSessionValue !== null) {
      const sessionValue = JSON.parse(callRecordingSessionValue);
      setCallRecordingData(sessionValue);
    }
  }, []);

  useEffect(() => {
    let timer = setTimeout(() => {
      UpdateLoginNumber();
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const UpdateLoginNumber = () => {
    const userInfoString = sessionStorage.getItem("UserInfo");
    if (userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      setLoggedInUserInfo(userInfo);
      const callerId = sessionStorage.getItem("callerId");
      if (callerId) {
        SetLoginNumber(callerId);
      } else {
        CallRecordingService.login(userInfo.email).then((response) => {
          if (response.IsSuccessful) {
            var loginNumber = formatPhoneNumber(response.StatusMessage);
            sessionStorage.setItem("callerId", formatPhoneNumber(loginNumber));
            SetLoginNumber(loginNumber);
          }
        }).catch((error) => {
          const errorMessage = error?.response?.data.ErrorMessage ? error?.response?.data.ErrorMessage : error?.response?.data
          toast.error(errorMessage);
        });
      }
    }
  }

  function notifyServer(sessionId: any) {
    if (sessionId && readyState === ReadyState.OPEN) {
      sendJsonMessage({
        "action": "ClientToServer",
        "data": {
          "SessionId": sessionId
        }
      });
    }
  }

  useEffect(() => {
    if (callRecordingData !== null) {
      setIsFirstCallStarted(callRecordingData.sessionId !== undefined && callRecordingData.sessionId !== null && callRecordingData.callback?.CallState > 0);
      setIsSecondCallStarted(callRecordingData.caller2 !== undefined && callRecordingData.caller2 !== null);
      setIsThirdCallStarted(callRecordingData.caller3 !== undefined && callRecordingData.caller3 !== null);
      setIsForthCallStarted(callRecordingData.caller4 !== undefined && callRecordingData.caller4 !== null);
      setIsFifthCallStarted(callRecordingData.caller5 !== undefined && callRecordingData.caller5 !== null);
      sessionStorage.setItem(callRecordingSessionKey, JSON.stringify(callRecordingData));

    }
    else {
      setIsFirstCallStarted(false);
      setIsSecondCallStarted(false);
      setIsThirdCallStarted(false);
      setIsForthCallStarted(false);
      setIsFifthCallStarted(false);
      sessionStorage.removeItem(callRecordingSessionKey);
    }
  }, [callRecordingData]);

  const forms = {
    firstForm: useForm<CallRecordingFirstFormData>(),
    secondForm: useForm<CallRecordingParticipantFormData>({
      defaultValues: { callerIndex: 2 }
    }),
    thirdForm: useForm<CallRecordingParticipantFormData>({
      defaultValues: { callerIndex: 3 }
    }),
    forthForm: useForm<CallRecordingParticipantFormData>({
      defaultValues: { callerIndex: 4 }
    }),
    fifthForm: useForm<CallRecordingParticipantFormData>({
      defaultValues: { callerIndex: 5 }
    }),
  }

  const getUserName = () => {
    const userInfoString = sessionStorage.getItem("UserInfo");
    if (userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      var userName = userInfo.userName.split(' ');
      if (userName) {
        if (userName.length == 1) {
          return {
            firstName: userName[0],
            lastName: null
          }
        } else {
          return {
            firstName: userName[0],
            lastName: userName[1]
          }
        }
      }
    }
    return null;
  }

  const onFirstSubmit = (data: CallRecordingFirstFormData) => {
    const id = toast.loading("Please wait...");
    var userInfo = getUserName();
    setIsFirstPlaceCallButtonDisable(true);
    setIsCallTerminatedManually(false);
    resetTimer();
    CallRecordingService.startCall(data.firstNumber, data.recordingName, loggedInUserInfo?.email, data.studyName, userInfo?.firstName, userInfo?.lastName)
      .then((response) => {
        toast.update(id, { render: "Establishing first call", type: "success", isLoading: false, autoClose: 5000 });
        const callRecording: CallRecordingData = {
          firstCall: data,
          sessionId: response.SessionInfo.SessionId
        }
        setCallRecordingData((call: CallRecordingData) => ({ ...call, ...callRecording }));
        notifyServer(response.SessionInfo?.SessionId);
      })
      .catch((error) => {
        const errorMessage = error?.response?.data.ErrorMessage ? error?.response?.data.ErrorMessage : error?.response?.data
        toast.update(id, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 });
      }).finally(() => {
        setIsFirstPlaceCallButtonDisable(false);
      });
  }

  const disableButton = (callerIndex: number, isDisable: boolean) => {
    switch (callerIndex) {
      case 2:
        setIsSecondPlaceCallButtonDisable(isDisable);
        break;
      case 3:
        setIsThirdPlaceCallButtonDisable(isDisable);
        break;
      case 4:
        setIsForthPlaceCallButtonDisable(isDisable);
        break;
      case 5:
        setIsFifthPlaceCallButtonDisable(isDisable);
        break;
    }
  }

  const onSecondSubmit = (data: CallRecordingParticipantFormData, callerIndex: number) => {
    const id = toast.loading("Please wait...");
    disableButton(callerIndex, true);
    if (!callRecordingData?.sessionId) {
      toast.update(id, { render: "Cannot add second caller until first call has been established.", type: "error", isLoading: false, autoClose: 5000 });
      disableButton(callerIndex, false);
      return;
    }

    CallRecordingService.addtocall(callRecordingData.sessionId, data.participantNumber, callerIndex)
      .then((response) => {
        if (response.IsSuccessful) {
          toast.update(id, { render: "Establishing second call", type: "success", isLoading: false, autoClose: 5000 });
          switch (callerIndex) {
            case 2:
              setCallRecordingData((call: CallRecordingData) => ({ ...call, caller2: data }));
              break;
            case 3:
              setCallRecordingData((call: CallRecordingData) => ({ ...call, caller3: data }));
              break;
            case 4:
              setCallRecordingData((call: CallRecordingData) => ({ ...call, caller4: data }));
              break;
            case 5:
              setCallRecordingData((call: CallRecordingData) => ({ ...call, caller5: data }));
              break;
          }
        }
        else {
          toast.update(id, { render: response.ErrorMessage, type: "error", isLoading: false, autoClose: 5000 });
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data.ErrorMessage ? error?.response?.data.ErrorMessage : error?.response?.data
        toast.update(id, { render: errorMessage, type: "error", isLoading: false, autoClose: 5000 });
      }).finally(() => {
        disableButton(callerIndex, false);
      });
  }

  const resetCallRecording = () => {
    setCallRecordingData(null);
    setIsAddThirdCaller(false);
    setIsAddForthCaller(false);
    setIsAddFifthCaller(false);
    resetTimer();
  }

  const resetTimer = () => {
    setIsTimerRunning(false);
    setResetTimer();
  }

  const onStopRecordingCall = () => {
    setIsRecordingButtonDisable(true);
    CallRecordingService.stopRecording(callRecordingData.sessionId)
      .then((response) => {
        toast.success("Recording has been successfully stopped. This call will not be recorded");
        setIsRecordingStopped(!isRecordingStopped);
      })
      .catch((error) => {
        toast.error(error.response.data);
      }).finally(() => {
        setIsRecordingButtonDisable(false);
      });
  };
  const onTerminateCall = () => {
    setIsCallTerminatedManually(true);
    resetCallRecording();
    CallRecordingService.hangUpCall(callRecordingData.sessionId)
      .then((response) => {
      })
      .catch((error) => {
        toast.error(error.response.data);
      });
  };
  const isJson = (str: any) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const formatPhoneNumber = (value: any) => {
    if (!value) return value;
    var currentValue = value.replace(/\D/g, '').slice(-10);
    const cvLength = currentValue.length;

    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return `${currentValue.slice(0, 3)}-${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  };

  /* Below are the code for DTMF tone
  const listOfNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9, '*', 0, '#'];
  const [dtmfKeys, setDtmfKeys] = useState('');
  const onDTMFClick = (number: any) => {
    let finalNum = dtmfKeys;
    if (!finalNum || finalNum === '') {
      finalNum = number;
    }
    else {
      finalNum += `,${number}`
    }
    setDtmfKeys(finalNum);
    console.log(`number you pressed ${number} : ${finalNum}`);
  }

  const submitDTMF = () => {
    CallRecordingService.sendDTMF(callRecordingData.sessionId, dtmfKeys, callRecordingData.caller2?.participantNumber)
      .then((response) => {
        clearDTMF();
      })
      .catch((error) => {
        toast.error(error.response.data);
      });
  }
  const clearDTMF = () => {
    setDtmfKeys('');
  }
  */
  /* Below are the code for Custom Login
  const [isLoginButtonDisable, setIsLoginButtonDisable] = useState(false);
  const [login, setLogin] = useState("");
   const [loginRequired, setLoginRequired] = useState(false);
 
   const customLogin = () => {
     if (login) {
       setIsLoginButtonDisable(true);
       CallRecordingService.login(login).then((response) => {
         if (response.IsSuccessful) {
           setLoggedInUserInfo((info: any) => ({ ...info, email: login }));
           SetLoginNumber(response.StatusMessage);
         }
       }).catch((error) => {
         const errorMessage = error?.response?.data.ErrorMessage ? error?.response?.data.ErrorMessage : error?.response?.data
         toast.error(errorMessage);
       }).finally(() => {
         setIsLoginButtonDisable(false);
       });
     }
     else {
       setLoginRequired(true);
     }
   }
   const setLoginValue = (email: any) => {
     setLogin(email);
     setLoginRequired(!email);
   }
 */
  return (
    <div>
      <div className='row'>
        <div className='col-lg-8 col-sm-12 col-xs-12'>
          <h2 className='callRecording-h2'>Rivel Call Recorder</h2>
          <form onSubmit={forms.firstForm.handleSubmit(onFirstSubmit)} noValidate>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="studyName">Study Name</label>
                <input type="text" className="form-control"
                  {...forms.firstForm.register('studyName')}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="recordingName">Recording Name</label>
                <input type="text" className="form-control"
                  {...forms.firstForm.register('recordingName', {
                    required: {
                      value: true,
                      message: 'Recording Name is required'
                    }
                  })}
                />
                {forms.firstForm.formState.errors.recordingName && <small className="form-text  form-error">{forms.firstForm.formState.errors.recordingName.message}</small>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="firstNumber">Your Phone Number</label>
                <input type='hidden' value="2"
                  {...forms.thirdForm.register('callerIndex')} />
                <input type="text" className="form-control" placeholder="ex (800) 555-1212 or +44 791 123 4567"
                  {...forms.firstForm.register('firstNumber', {
                    required: "Your Phone number is required",
                    pattern: {
                      value: /^((\+\d{1}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|((\+\d{1,3}\s?)\(?\d{1,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{0,5})$/i,
                      message: "Invalid phone number"
                    }
                  })}
                />
                {forms.firstForm.formState.errors.firstNumber && <small className="form-text  form-error">{forms.firstForm.formState.errors.firstNumber.message}</small>}
              </div>
              <div className="form-group col-md-3 col-sm-3">
                {(callRecordingData == null || callRecordingData?.sessionId === null)
                  ?
                  <button type="submit" className="btn btn-outline-success"
                    disabled={isFirstPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                  : null
                }
              </div>
            </div>
          </form>
          <form onSubmit={forms.secondForm.handleSubmit((data) => onSecondSubmit(data, 2))} noValidate className='needs-validation'>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="participantNumber">Second Participant Phone Number</label>
                <input type='hidden'
                  {...forms.secondForm.register('callerIndex')} />
                <input type="text" className="form-control" placeholder="ex (800) 555-1212 or +44 791 123 4567"
                  {...forms.secondForm.register('participantNumber', {
                    required: "Second number is required",
                    pattern: {
                      value: /^((\+\d{1}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|((\+\d{1,3}\s?)\(?\d{1,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{0,5})$/i,
                      message: "Invalid phone number"
                    }
                  })}
                />
                {forms.secondForm.formState.errors.participantNumber && <small className="form-text  form-error">{forms.secondForm.formState.errors.participantNumber.message}</small>}
              </div>
              <div className="form-group col-md-3 col-sm-3">
                {(!isFirstCallStarted || !isSecondCallStarted)
                  ? <button type="submit" className="btn btn-outline-success"
                    disabled={isSecondPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                  : !isAddThirdCaller ? <button type="button" className="btn btn-outline-success"
                    style={{ margin: "30px 0 0 0" }} onClick={() => setIsAddThirdCaller(true)} >+</button> : null
                }
              </div>
            </div>
          </form>
          {isAddThirdCaller ? <form onSubmit={forms.thirdForm.handleSubmit((data) => onSecondSubmit(data, 3))} noValidate className='needs-validation'>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="participantNumber">Third Participant Phone Number</label>
                <input type='hidden'
                  {...forms.thirdForm.register('callerIndex')} />
                <input type="text" className="form-control" placeholder="ex (800) 555-1212 or +44 791 123 4567"
                  {...forms.thirdForm.register('participantNumber', {
                    required: "Third number is required",
                    pattern: {
                      value: /^((\+\d{1}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|((\+\d{1,3}\s?)\(?\d{1,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{0,5})$/i,
                      message: "Invalid phone number"
                    }
                  })}
                />
                {forms.thirdForm.formState.errors.participantNumber && <small className="form-text  form-error">{forms.thirdForm.formState.errors.participantNumber.message}</small>}
              </div>
              <div className="form-group col-md-3 col-sm-3">
                {(!isThirdCallStarted)
                  ? <> <button type="submit" className="btn btn-outline-success"
                    disabled={isThirdPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                    <button type="button" className="btn btn-outline-success" disabled={isThirdPlaceCallButtonDisable}
                      style={{ margin: "30px 0 0 10px" }} onClick={() => setIsAddThirdCaller(false)}>-</button>
                  </>
                  :
                  isFirstCallStarted && isSecondCallStarted && !isAddForthCaller
                    ? <button type="button" className="btn btn-outline-success"
                      style={{ margin: "30px 0 0 0" }} onClick={() => setIsAddForthCaller(true)}>+</button>
                    : null
                }

                {/* {(!isFirstCallStarted || !isSecondCallStarted)
                  ? <button type="submit" className="btn btn-outline-success"
                    disabled={isSecondPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                  : null
                } */}
              </div>
            </div>
          </form>
            : null
          }
          {isAddForthCaller ? <form onSubmit={forms.forthForm.handleSubmit((data) => onSecondSubmit(data, 4))} noValidate className='needs-validation'>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="participantNumber">Forth Participant Phone Number</label>
                <input type='hidden'
                  {...forms.forthForm.register('callerIndex')} />
                <input type="text" className="form-control" placeholder="ex (800) 555-1212 or +44 791 123 4567"
                  {...forms.forthForm.register('participantNumber', {
                    required: "Forth number is required",
                    pattern: {
                      value: /^((\+\d{1}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|((\+\d{1,3}\s?)\(?\d{1,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{0,5})$/i,
                      message: "Invalid phone number"
                    }
                  })}
                />
                {forms.forthForm.formState.errors.participantNumber && <small className="form-text  form-error">{forms.forthForm.formState.errors.participantNumber.message}</small>}
              </div>
              <div className="form-group col-md-3 col-sm-3">
                {(!isForthCallStarted)
                  ? <> <button type="submit" className="btn btn-outline-success"
                    disabled={isForthPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                    <button type="button" className="btn btn-outline-success" disabled={isForthPlaceCallButtonDisable}
                      style={{ margin: "30px 0 0 10px" }} onClick={() => setIsAddForthCaller(false)}>-</button>
                  </>
                  :
                  isForthCallStarted && !isAddFifthCaller
                    ? <button type="button" className="btn btn-outline-success"
                      style={{ margin: "30px 0 0 0" }} onClick={() => setIsAddFifthCaller(true)}>+</button>
                    : null
                }
                {/* {(!isFirstCallStarted || !isSecondCallStarted)
                  ? <button type="submit" className="btn btn-outline-success"
                    disabled={isSecondPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                  : null
                } */}
              </div>
            </div>
          </form>
            : null
          }
          {isAddFifthCaller ? <form onSubmit={forms.fifthForm.handleSubmit((data) => onSecondSubmit(data, 5))} noValidate className='needs-validation'>
            <div className="form-row">
              <div className="form-group col-md-9 col-sm-9">
                <label htmlFor="participantNumber">Fifth Participant Phone Number</label>
                <input type='hidden'
                  {...forms.fifthForm.register('callerIndex')} />
                <input type="text" className="form-control" placeholder="ex (800) 555-1212 or +44 791 123 4567"
                  {...forms.fifthForm.register('participantNumber', {
                    required: "Fifth number is required",
                    pattern: {
                      value: /^((\+\d{1}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|((\+\d{1,3}\s?)\(?\d{1,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{0,5})$/i,
                      message: "Invalid phone number"
                    }
                  })}
                />
                {forms.fifthForm.formState.errors.participantNumber && <small className="form-text  form-error">{forms.fifthForm.formState.errors.participantNumber.message}</small>}
              </div>
              <div className="form-group col-md-3 col-sm-3">
                {(!isFifthCallStarted)
                  ? <> <button type="submit" className="btn btn-outline-success"
                    disabled={isFifithPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                    <button type="button" className="btn btn-outline-success" disabled={isFifithPlaceCallButtonDisable}
                      style={{ margin: "30px 0 0 10px" }} onClick={() => setIsAddFifthCaller(false)}>-</button>
                  </>
                  :
                  isForthCallStarted && !isAddFifthCaller
                    ? <button type="button" className="btn btn-outline-success"
                      style={{ margin: "30px 0 0 0" }}>+</button>
                    : null
                }
                {/* {(!isFirstCallStarted || !isSecondCallStarted)
                  ? <button type="submit" className="btn btn-outline-success"
                    disabled={isSecondPlaceCallButtonDisable}
                    style={{ margin: "30px 0 0 0" }}>Place Call</button>
                  : null
                } */}
              </div>
            </div>
          </form>
            : null
          }
          <div className="row">
            <div className="col-lg-4 col-sm-12 col-xs-12">
              <button type="submit" className="btn btn-outline-primary"
                disabled={callRecordingData?.sessionId == null}
                onClick={onTerminateCall}
                style={{ margin: "30px 0 0 0" }}>Terminate Call</button>
            </div>
          </div>
          <div className='text-right mt-4'>
            {loginNumber && <div className='callerId' style={{ margin: "0 55px 0 0" }}>Caller ID Phone Number: {loginNumber}</div>}
            {/* Below are the code for Custom Login
            <div style={{ margin: "15px 0 0 0" }}>
              <div className="form-row">
                <div className="form-group col-md-10 col-sm-10">
                  <label htmlFor="customLogin" style={{ margin: "7px 10px" }}>Custom Login</label>
                  <input type="text"
                    value={login}
                    onChange={(e) => setLoginValue(e.target.value)} />

                  {loginRequired && <small className="form-text  form-error">Login is required</small>}
                </div>
                <div className="form-group col-md-2 col-sm-2 text-left">
                  <button className="btn btn-primary" disabled={isLoginButtonDisable} onClick={customLogin}>Login</button>

                </div>
              </div>
            </div> */}
          </div>
        </div>
        {isFirstCallStarted &&
          <div className='col-lg-4 col-sm-12 col-xs-12' >
            <div className="d-flex" style={{ height: "500px" }}>
              <div className="vr"></div>
              <div className='container right-side-call-info'>
                <div className={(isInProgress ? "CallNotStarted" : "CallStarted")}><h4>Call Established</h4></div>
                <div className={(isInProgress ? "CallStarted" : "CallNotStarted")}>
                  <h2 className='justify-center'>Call</h2>
                  <h3 className='justify-center'>In Progress</h3>
                  <div className='call-timer'>
                    <div>
                      {timerOutput}
                    </div>
                  </div>
                  <div style={{ margin: "10px 0 10px 0" }}>
                    {
                      isRecordingStopped ?
                        <img src="/images/recording-stop.png" alt="start" width={120} />
                        : <img src="/images/recording-start.png" alt="start" width={120} />
                    }
                  </div>
                  <div className="form-check">
                    <label className="form-check-label form-check-toggle" title="On click it will stop recording">
                      <input className="form-check-input" type="checkbox"
                        disabled={isRecordingButtonDisable || isRecordingStopped == true}
                        onChange={onStopRecordingCall} checked={isRecordingStopped == false} /><span></span>
                    </label>
                  </div>
                  {/* <div className='mt-4'>
                    <div>Participants</div>
                    {
                      listOfNumber.map((number) =>
                        <div key={number}>Participant #{number}</div>
                      )
                    }
                  </div> */}
                  {/* <div className='mt-2'>
                    <div>Dial Pad</div>
                    <p>{dtmfKeys}</p>
                    <div className='calculator-keys mt-2'>
                      {
                        listOfNumber.map((number) =>
                          <button type="button" value="{number}" key={number} onClick={() => onDTMFClick(number)} className="btn btn-light waves-effect">{number}</button>
                        )
                      }
                    </div>
                    <div className='mt-2' style={{ paddingBottom: "5rem" }}>
                      <button type='button' onClick={submitDTMF} className="btn btn-outline-primary waves-effect mr-3">Submit DTMF</button>
                      <button type='button' onClick={clearDTMF} className="btn btn-outline-warning waves-effect">Clear DTMF</button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        }
        {/* <DevTool control={forms.firstForm.control} />
        <DevTool control={forms.secondFOrm.control} /> */}
      </div>
    </div>
  )
}

export default CallRecording